import { message } from "ant-design-vue";
import store from '@/store/index'
export const notify =  (text, type, duration) => {
  window.parent.postMessage({
    tag:'__atmAdminVue__',
    fnName:'notify',
    fnParams:{
      text,
      type,
      duration
    }
  },store.state.atmStore.atmWebOrigin);
  // switch (type) {
  //   case 'success':

  //   case 'warn':
  //   case 'info':
  //     message[type](text, (duration || 1500)/1000)
  //     break
  //   case 'loading':
  //     message[type](text, (duration || 500)/1000)
  //     break
  //   case 'error':
  //     message[type](text, (duration || 3000)/1000)
  //     break
  //   default:
  //     message.error(text, (duration || 1500)/1000)

  // }
}